import {
  SET_PREFERENCE_DATA,
  SET_SETTINGS_DATA,
  SET_COMPANY_SETTINGS_DATA,
  SET_INVENTORY_DATA,
  SET_VM_COUNT,
  SET_PRODUCT_SETTINGS_DATA,
  SET_PRODUCT_CATEGORIES_DATA,
  SET_REPORTED_CATEGORIES_DATA,
} from "../constants/action-types";

const initialState = {
  preferenceData: {},
  settingsData: {},
  companySettingsData: {},
  productSettingsData: {},
  productCategoriesData: {},
  reportedCategoriesData: {},
};

const initialLoadReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PREFERENCE_DATA:
      return { ...state, preferenceData: action.payload };
    case SET_SETTINGS_DATA:
      return { ...state, settingsData: action.payload };
    case SET_COMPANY_SETTINGS_DATA:
      return { ...state, companySettingsData: action.payload };
    case SET_INVENTORY_DATA:
      return {
        ...state,
        inventoryData: action.payload,
      };
    case SET_VM_COUNT:
      return {
        ...state,
        vmCount: action.payload,
      };
    case SET_PRODUCT_SETTINGS_DATA:
      return {
        ...state,
        productSettingsData: action.payload,
      };
    case SET_PRODUCT_CATEGORIES_DATA:
      return {
        ...state,
        productCategoriesData: action.payload,
      };
    case SET_REPORTED_CATEGORIES_DATA:
      return {
        ...state,
        reportedCategoriesData: action.payload,
      };
    default:
      return state;
  }
};

export default initialLoadReducer;
